<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cqeQlh/tc-custom/9780830864492.jpg?1696374802061" alt="This image is the cover for the book The Church, God's Word for Today"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Church, God's Word for Today
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>How can Christians effectively engage today's world while staying true to Scripture?</strong> Calling us to listen well to both the Word and the world, John Stott shows how Christianity can preserve its authentic identity <em>and</em> remain relevant to current realities. With the God's Word for Today series, pastor Tim Chester has updated Stott's classic book <em>The Contemporary Christian</em> and made it accessible to new generations of readers. In<em>The Church</em>, Stott presents a biblical portrait of the church as a covenant community at the center of God's purposes. Keeping in view both the ideal of what God intends and how we fall short, Stott considers how the church can be sensitive to current needs and societal issues, mobilize people for mission, seek holistic renewal, and promote healthy leadership. Each chapter includes stories, practical suggestions, and questions for reflection or discussion. People are hungry for transcendence, significance, and community. This is the great challenge and opportunity facing the church—will we cooperate with the Spirit so that others can find what they seek in Christ and his people?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Stott, Tim Chester
      </h2>
      
      <p class="authorDescription body article"><p>John R. W. Stott (1921–2011) was known worldwide as a preacher, evangelist, and communicator of Scripture. For many years he served as rector of All Souls Church in London, where he carried out an effective urban pastoral ministry. A leader among global evangelicals, Stott was a principal framer of the landmark Lausanne Covenant. His many books include <em>Basic Christianity</em>, <em>The Cross of Christ</em>, and <em>Christian Mission in the Modern World</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      IVP
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e7e3a9a2